module.exports = __webpack_public_path__ + "img/tdbase.4637b0e6.png";